module.exports = "<span *ngFor=\"let tag of tags\" class=\"badge badge-avanto badge-pill ml-1\">\r\n    {{tag}}\r\n</span>"